<template>
  <div class="sm_star">
    <!-- header -->
    <!-- <div class="sm_header">
			<h1>Samsung STAR</h1>
			<button class="menu_btn"><span>mobile menu</span></button>
		</div> -->
    <TopAppBar
      :leftBtnMode="leftBtnMode"
      :rightBtnMode="rightBtnMode"
      :title="title"
      :leftBtnMethod="leftBtnMethods"
      :rightBtnMethod="rightBtnMethod"
      ref="top_app_bar"
    >
    </TopAppBar>
    <!-- //header -->

    <!-- content -->
    <div
      class="d-flex flex-column t-center"
      style="background-color: #2d6dcc; height: 100vh"
      v-if="!filedata"
    >
      <img src="/images/01_Samsung_logo.png" style="margin-top: 40%" />
    </div>
    <!-- {{ filedata }} -->
    <div
      class="sm_content"
      style="width: 100%; padding-top: 54px"
      v-if="filedata && filedata.resourceUri"
    >
      <img
        v-if="getType(filedata.contentType) === 'image'"
        :src="filedata.resourceUri"
        :alt="filedata.originalName"
      />
      <video-player
        class="video-player-box"
        v-if="getType(filedata.contentType) === 'video'"
        ref="videoPlayer"
        :options="getPayerOption(filedata)"
        :playsinline="true"
      />
    </div>
    <!-- //content -->
  </div>
</template>

<script>
import TopAppBar from "@/components/TopAppBar.vue";
import { topAppBarMixin } from "../../mixins/topAppBar.js";
import "video.js/dist/video-js.css";
import { videoPlayer } from "vue-video-player";
export default {
  components: {
    videoPlayer,
    TopAppBar,
  },
  props: ["filedata"],
  data() {
    return {
      file: null,
    };
  },

  mixins: [topAppBarMixin],

  mounted() {
    this.setTopAppBarCloseSocialPopup("");
    this.file = JSON.parse(localStorage.getItem("socialFile"));
    this.file = this.filedata;
    console.log("I amgatting=============", this.file);
  },
  methods: {
    getType(contentType) {
      return contentType.split("/")[0];
    },
    getPayerOption(img) {
      //alert($(window).width())
      return {
        //muted: true,
        language: "en",
        controls: true,
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [
          {
            type: img.contentType,
            src: img.resourceUri,
          },
        ],
        height: $(window).height() - 100,
        width: $(window).width() - 10,
      };
    },
    leftBtnMethods() {
      this.$emit("closePopup");
    },
  },
};
</script>
